import { render } from "./SoftSelect.vue?vue&type=template&id=005d7dd3&scoped=true"
import script from "./SoftSelect.vue?vue&type=script&lang=js"
export * from "./SoftSelect.vue?vue&type=script&lang=js"

import "./SoftSelect.vue?vue&type=style&index=0&id=005d7dd3&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-005d7dd3"]])

export default __exports__